import React from 'react';

import { Label } from '@sopranodesign/pulse-components';
import { TemplatingTextArea } from '@sopranodesign/pulse-templating';

import { useComposer } from '../../../../hooks/index';

const MarkdownInput = () => {
  const {
    response: { content },
    dispatch
  } = useComposer();

  const handleResponseChange = value => {
    dispatch({ type: 'UPDATE_CONTENT', newContent: { text: value } });
  };

  return (
    <div>
      <Label htmlFor="markdown">Message</Label>
      <TemplatingTextArea
        id="markdown"
        name="markdown"
        value={content.text}
        onChange={handleResponseChange}
      />
    </div>
  );
};

export default MarkdownInput;
